import { useEffect, useState } from "react";
import { calculatePostDate } from "../../../../../Helpers/format-helper";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../shadcnComponents/ui/table";
import {
  RoundedPillTag,
  TableBodyCell,
} from "../../../../Influencer/CreateProfileV1/Components";
import { MdAdsClick } from "react-icons/md";
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
} from "../../../../../shadcnComponents/ui/chart";
import { Bar, BarChart, CartesianGrid } from "recharts";
// import { Calendar } from "../../../../../shadcnComponents/ui/calendar";
import { PickDateBtn, SectionCard } from "./molecules";
import { Tooltip as RechartsTooltip } from "recharts";
import { CustomTooltip } from "../../../../Influencer/PublicProfile/Component";
import PostCalendar from "./post-calender";
import React from "react";
import { DateRange } from "react-day-picker";
import { format } from "date-fns";

export const PostPerformanceTable = ({
  postData,
}: {
  postData: {
    posts: {
      postFeedUrl?: string;
      postDescription: string;
      postType?: string[];
      postCreatedOn?: string;
      likes?: number;
      comments?: number;
      reposts?: number;
      impressions?: number;
      engagement?: number;
      impressionRank?: number;
      postFormatType?:
        | "video"
        | "image"
        | "text"
        | "feed"
        | "repost"
        | "carousel";
    }[];
  };
}) => {
  const [extData, setExtData] = useState(postData);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");

  useEffect(() => {
    if (postData?.posts) {
      setExtData((prev) => ({ ...prev, posts: postData?.posts }));
    }
  }, [postData?.posts]);

  const handleSort = (column) => {
    const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    setSortColumn(column);

    const sortedPosts = [...extData.posts].sort((a, b) => {
      let valueA = a[column] || 0;
      let valueB = b[column] || 0;

      if (column === "postCreatedOn") {
        valueA = new Date(a[column]);
        valueB = new Date(b[column]);
      }
      return order === "asc" ? valueA - valueB : valueB - valueA;
    });

    setExtData((prev) => ({ ...prev, posts: sortedPosts }));
  };

  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className="border border-[#262626] relative rounded-[10px]  overflow-auto"
    >
      <Table className="min-w-[360px] w-full ">
        <TableHeader className="sticky top-0 bg-[#393939] z-10 px-5">
          <TableRow className="bg-[#393939] hover:bg-[#393939] hover:rounded-lg border-b border-[#262626]">
            <TableHead className="min-w-[90px] rounded-tl-[10px] text-center text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
              S. No.
            </TableHead>
            <TableHead className="text-start  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
              Posts
            </TableHead>
            <TableHead
              className="text-right cursor-pointer  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5"
              onClick={() => handleSort("postCreatedOn")}
            >
              <div className="flex gap-1 justify-center">
                <div>Created on</div>
                <div>
                  {sortColumn === "postCreatedOn" &&
                    (sortOrder === "asc" ? "↑" : "↓")}
                </div>
              </div>
            </TableHead>
            <TableHead className="text-center cursor-pointer  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5">
              Format
            </TableHead>
            <TableHead
              className="text-right cursor-pointer  text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5"
              onClick={() => handleSort("likes")}
            >
              <div className="flex gap-1">
                <div>Likes</div>
                <div>
                  {sortColumn === "likes" && (sortOrder === "asc" ? "↑" : "↓")}
                </div>
              </div>
            </TableHead>
            <TableHead
              className="text-right cursor-pointer text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5"
              onClick={() => handleSort("comments")}
            >
              <div className="flex gap-1">
                <div>Comments</div>
                <div>
                  {sortColumn === "comments" &&
                    (sortOrder === "asc" ? "↑" : "↓")}
                </div>
              </div>
            </TableHead>
            <TableHead
              className="text-right cursor-pointer text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5"
              onClick={() => handleSort("impressions")}
            >
              <div className="flex gap-1">
                <div>Impressions</div>
                <div>
                  {sortColumn === "impressions" &&
                    (sortOrder === "asc" ? "↑" : "↓")}
                </div>
              </div>
            </TableHead>
            <TableHead
              className="text-right rounded-tr-[10px] cursor-pointer text-[#CCC] font-[Inter] text-sm not-italic font-bold leading-[24px] py-3 px-5"
              onClick={() => handleSort("engagement")}
            >
              <div className="flex gap-1">
                <div>Engagement</div>
                <div>
                  {sortColumn === "engagement" &&
                    (sortOrder === "asc" ? "↑" : "↓")}
                </div>
              </div>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {extData?.posts?.length === 0 && (
            <TableRow className="hover:bg-transparent">
              <TableCell colSpan={8} className="text-center">
                No posts found
              </TableCell>
            </TableRow>
          )}
          {extData?.posts?.map((post, index) => {
            const isLastRow = index === extData?.posts?.length - 1;

            const postDate = post?.postCreatedOn
              ? new Date(post?.postCreatedOn)
              : calculatePostDate(post?.postFeedUrl);

            return (
              <TableRow
                key={index}
                className={`hover:bg-[#262626] px-5 py-4 ${
                  !isLastRow && "border-b border-[#262626]"
                }`}
              >
                <TableBodyCell
                  className={`${isLastRow ? "rounded-bl-[10px]" : ""}`}
                >
                  {index + 1}
                </TableBodyCell>
                <TableBodyCell
                  className="text-start"
                  title={post?.postDescription}
                  // onClick={() => {
                  //   window.open(post?.postFeedUrl, "_blank");
                  // }}
                >
                  <div className="max-w-[300px] overflow-hidden text-ellipsis whitespace-nowrap">
                    <div className="flex flex-col gap-2">
                      <div className="line-clamp-1 w-full overflow-hidden text-ellipsis">
                        {post?.postDescription?.slice(0, 50)}
                      </div>
                      {post?.impressionRank === 1 &&
                        post?.impressions !== 0 && (
                          <div className="flex gap-1.5 items-center justify-center w-fit px-3 py-1.5 rounded-sm bg-[#0077B5] border border-[#0077B599]">
                            <MdAdsClick size={12} className="text-white" />
                            <span className="font-[Inter] text-[10px] not-italic font-medium leading-[normal]">
                              Highest Impression Post
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                </TableBodyCell>
                <TableBodyCell
                  title={postDate?.toLocaleString()}
                  className="text-center"
                >
                  {/* {formatDistance(postDate, new Date(), {
                    addSuffix: true,
                  })} */}
                  {format(postDate, "MMM dd, yyyy") || "-"}
                </TableBodyCell>
                <TableBodyCell>
                  <RoundedPillTag variant={post?.postFormatType}>
                    {post?.postFormatType}
                  </RoundedPillTag>
                </TableBodyCell>
                <TableBodyCell>
                  {post?.likes > 0 ? post?.likes?.toLocaleString() : "-"}
                </TableBodyCell>
                <TableBodyCell>
                  {post?.comments > 0 ? post?.comments?.toLocaleString() : "-"}
                </TableBodyCell>
                <TableBodyCell>
                  {post?.impressions > 0
                    ? post?.impressions?.toLocaleString()
                    : "-"}
                </TableBodyCell>
                <TableBodyCell
                  className={`${isLastRow ? "rounded-br-[10px]" : ""}`}
                >
                  {post?.engagement > 0
                    ? Math.ceil(post?.engagement * 10) / 10 + "%"
                    : "-"}
                </TableBodyCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export const PostPerformanceSkeleton = () => {
  return (
    <div className="h-full p-10 flex flex-col gap-6">
      <div className=" grid grid-cols-5 py-4 gap-6 animate-pulse">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="border border-[#262626] rounded-[10px] bg-[#262626] w-full h-24 "
          ></div>
        ))}
      </div>
      <div className="flex justify-between animate-pulse">
        <div className="border border-[#262626] rounded-[10px] bg-[#262626] w-1/6 h-10"></div>
        <div className="border border-[#262626] rounded-[10px] bg-[#262626] w-1/6 h-10"></div>
      </div>
      <div className="">
        <div className="py-6 flex flex-col gap-3 animate-pulse">
          <span className="text-xl bg-[#262626] w-40 h-6 rounded-full"></span>
          <div className="border border-[#262626] rounded-[10px] bg-[#262626] w-full h-60"></div>
        </div>
      </div>
    </div>
  );
};

interface PostBarGraphAreaProps {
  firstThirtyLikes: string[] | undefined;
  firstThirtyComments: string[] | undefined;
  posts?: [
    {
      postCreatedOn: string;
      likes: string;
      comments: string;
    }
  ];
}

export const PostBarGraphArea: React.FC<PostBarGraphAreaProps> = ({
  firstThirtyLikes,
  firstThirtyComments,
  posts,
}) => {
  const [graphDateRange, setGraphDateRange] = React.useState<
    DateRange | undefined
  >({
    from: null,
    to: null,
  });

  const [chartData, setChartData] = React.useState([]);

  useEffect(() => {
    const updatedChartData = firstThirtyLikes?.map((item, index) => {
      const originalLikes = parseInt(item);
      const originalComments = parseInt(firstThirtyComments?.[index] || "0");
      const likesLog = Math.log10(originalLikes + 1);
      const commentsLog = Math.log10(originalComments + 1);

      return {
        month: `post ${index + 1}`,
        likes: likesLog,
        comments: commentsLog,
        originalLikes,
        originalComments,
      };
    });

    setChartData(updatedChartData);
  }, [firstThirtyLikes, firstThirtyComments]);

  const chartConfig = {
    comments: {
      label: "Comments",
      color: "#F9C017",
    },
    likes: {
      label: "Likes",
      color: "#4B72FF",
    },
  } satisfies ChartConfig;

  useEffect(() => {
    if (graphDateRange?.from && graphDateRange?.to && posts?.length > 0) {
      const filteredPosts = posts?.filter((post) => {
        const postDate = new Date(post?.postCreatedOn);
        return (
          postDate >= graphDateRange?.from && postDate <= graphDateRange?.to
        );
      });
      const updatedChartData = filteredPosts
        ?.map((post, index) => {
          const originalLikes = parseInt(post?.likes);
          const originalComments = parseInt(post?.comments || "0");
          const likesLog = Math.log10(originalLikes + 1);
          const commentsLog = Math.log10(originalComments + 1);

          return {
            month: `post ${index + 1}`,
            likes: likesLog,
            comments: commentsLog,
            originalLikes,
            originalComments,
          };
        })
        .reverse();

      setChartData(updatedChartData);
    }
  }, [graphDateRange, posts]);

  return (
    <>
      <SectionCard
        icon={"📊"}
        title="Post Performance"
        subtitle="Performance of your posts over time"
        parentClass="border-none"
        action={
          <PickDateBtn date={graphDateRange} setDate={setGraphDateRange} />
        }
      >
        <div className="h-full w-full flex flex-col items-center justify-center">
          <ChartContainer config={chartConfig} className="h-[250px] w-full">
            <BarChart accessibilityLayer data={chartData}>
              <CartesianGrid vertical={false} color="#212121" />
              <RechartsTooltip
                content={
                  <CustomTooltip active={undefined} payload={undefined} />
                }
                cursor={false}
              />
              <ChartLegend content={<ChartLegendContent />} />
              <Bar
                width={5}
                dataKey="likes"
                stackId="a"
                fill="var(--color-likes)"
                radius={[0, 0, 4, 4]}
              />
              <Bar
                width={5}
                dataKey="comments"
                stackId="a"
                fill="var(--color-comments)"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ChartContainer>

          <div className="w-full flex items-center justify-between">
            <span className=" text-xs font-medium leading-[14.52px] text-center text-[#A3A3A3]">
              Latest
            </span>
            <span className=" text-xs font-medium leading-[14.52px] text-center text-[#A3A3A3]">
              Oldest
            </span>
          </div>
        </div>
      </SectionCard>
    </>
  );
};

export const PostCalendarArea = ({ posts }) => {
  return (
    <>
      <SectionCard
        icon={"📆"}
        title="Post Frequency"
        parentClass="w-auto border-none"
      >
        <div className="w-full flex flex-col justify-center items-center">
          <PostCalendar posts={posts} />
        </div>
      </SectionCard>
    </>
  );
};
